import React, { Component } from 'react';
export function Header() {
  const handleScrollToForm = () => {
    const formSection = document.getElementById('offer');
    if (formSection) {
      formSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      setTimeout(() => {
        const firstInput = document.getElementById('nombre');
        if (firstInput) firstInput.focus();
      }, 500);
    }
  };
  return <header className="fixed top-0 left-0 right-0 z-50 bg-[#1A1A1A]/95 backdrop-blur-sm border-b border-white/10" data-id="element-92">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-3 md:py-4 flex items-center justify-between" data-id="element-93">
        <div className="flex items-center" data-id="element-94">
          <span className="text-xl md:text-2xl font-black text-white tracking-tight" data-id="element-95">
            GERFAJ
          </span>
          <span className="ml-2 text-xs text-white/60 font-light" data-id="element-96">S.A.S.</span>
        </div>
        <button onClick={handleScrollToForm} className="bg-[#E8621A] text-white px-6 md:px-8 py-3 rounded-full font-bold uppercase text-[13px] md:text-[15px] hover:bg-[#d55515] transition-colors shadow-lg shadow-[#E8621A]/20 min-h-[44px]" style={{
        lineHeight: '1',
        letterSpacing: '0.08em'
      }} data-id="element-97">
          Asesoría ¡GRATIS!
        </button>
      </div>
    </header>;
}